import MediaDevices from './MediaDevices/Manager';
import Producers from './Sfu/Producers';
import Consumers from './Sfu/Consumers';
import AudioManager from './Audio/Manager';
import { isIOS, isAndroid } from 'react-device-detect';

//const isIOS = true;
//const isAndroid = false;

export default class Manager {

    constructor(sdk) {
        this._isStarted = false;
        this._sdk = sdk;
        this._webcamHide = false;
        this._micMute = false;
        this._specificDevices = {};
        this._currentSpecificDevice = false;
        this.initDevicesData();
        this.initMediadevice();
        this._fakeConsumers = {};
        this._consumersHistory = {};
        this.doc2uState = false;
        this.doc2u = {};

        //if get param in url
        if(window.location.search.indexOf('forceIOS') !== -1) 
            isIOS = true;

        if (isIOS || isAndroid) {
            document.addEventListener('visibilitychange', () => {

                if(this.specificDeviceIsStarting) //we do that because we do not toggle webcam on hide
                    return;

                if (document.visibilityState == 'hidden') {
                    //this._sdk.fetch().sendBeacon('/signaling/visibilitychange/' + document.visibilityState);               
                    //if(!this.isWebcamHide()) {
                    this.toggleWebcamHide();
                    this.camHidedByVisibility = true;
                    //}
                } else if (document.visibilityState == 'visible') {
                    //this._sdk.fetch().sendBeacon('/signaling/visibilitychange/' + document.visibilityState);
                    if (this.camHidedByVisibility) {
                        this.toggleWebcamHide();
                    }

                }
            });
        }

        this.countTest = 0;
    }

    initDevicesData() {
        this._devicesLoaded = false;
        this._isDeviceLoading = false;
        this._devices = {};
        this._audioMandatoryMissing = [];
        this._videoMandatoryMissing = [];
        this._screenDevices = [];
        this._mandatoryDevices = [];
        this._mandatoryDevicesFinded = [];
        this._availableRemoteDevices = [];
    }

    initMediadevice() {
        this._mediaDevice = new MediaDevices({
            onDeviceUpdate: (data) => {
                this._sdk.event().emit('mediaDeviceUpdated', data);

                if (data.kind == 'audio') {
                    this._audioManager.stopMeter('main');

                    if (data.stream) {
                        let audioTrack = data.stream.getAudioTracks()[0]; //this._mediaDevice.getAudioTrack();
                        this._audioManager.createMeter('main', audioTrack, (data) => {
                            this._sdk.event().emit('audioMeterMain', data)
                        });
                    }
                }

                if (this._isStarted) {
                    this.updateProducer(data);
                }
            },
            onAudioOutputUpdate: (data) => {
                this._sdk.event().emit('audioOutputUpdated', data)
            },
            onVideoResolutionUpdate: (data) => {
                if (data.kind == 'send') {
                    this._producers.setActiveEncodings(data.value);
                    this._producers.updateBitrate('cam-video');
                }
                if (data.kind == 'recv') {
                    this._consumers.setPreferredLayers(data.value);
                    this._consumers.updateLayers('cam-video');
                }
            },
            onReady: () => {
                let audioTrack = this._mediaDevice.getAudioTrack();
                this._audioManager.createMeter('main', audioTrack, (data) => {
                    this._sdk.event().emit('audioMeterMain', data)
                });
            },
            onDeviceChange: async () => {
                if (window.isHomePage)
                    return;
                this._sdk.event().emit('loadingStart');

                let devices = this._mediaDevice.getDevices();
                let specificDevice = this.getCurrentSpecificDevice();
                if(specificDevice && specificDevice.role !== 'Doc2u' && specificDevice.kind) {                                        
                    console.log('specificDevice', specificDevice);
                    console.log('devices', devices);
                    let device = devices[specificDevice.kind].find((item) => item.deviceId === specificDevice.deviceId); 
                    if(!device) {
                        console.log('no specific device founded');
                        await this.stopSpecificDevice(specificDevice.deviceId)
                    } 
                }

                this.initDevicesData();
                await this.loadDevices();
                await this.sendDevices();
                this._sdk.event().emit('deviceChange');
                this._sdk.event().emit('loadingStop');
            }
        });

    }

    createGain() {
        let audioTrack = this._mediaDevice.getAudioTrack();
        this.gain = this._audioManager.createGain('main', audioTrack);
        this._mediaDevice.setGain(this.gain);
    }

    getGain() {
        if (!this.gain)
            this.createGain();
        return this.gain;
    }

    needInteraction() {
        this._audioManager = new AudioManager();
        this._audioManagerContextCreated = this._audioManager.createContext();
        return !this._audioManagerContextCreated;
    }

    async init() {
        if (!this._audioManagerContextCreated)
            this._audioManager.createContext();
        await this._audioManager.init();
    }

    mediaDevices() {
        return this._mediaDevice;
    }

    async loadDevices() {
        if (this._isDeviceLoading)
            return;
        this._isDeviceLoading = true;
        this._devices = await this._mediaDevice.enumerate();

        while (Object.keys(this._devices).length === 0) {
            await window.sdk.sleep(300);
            this._devices = await this._mediaDevice.enumerate(true);
        }

        if (this._sdk.session().isPatient()) {
            this.processDevices();
            await this.disableDefaultUserOfSpecificDevice();
        }

        let devices = this._sdk.settings().devices;
        for (var i in devices) {
            if (devices[i].screen)
                this._screenDevices.push(devices[i]);
        }

        this._devicesLoaded = true;

        if(this.doc2uState){
            this._mandatoryDevicesFinded.push(this.doc2u);
        }

        window.sdk.event().emit('refreshDevices');
    }

    async disableDefaultUserOfSpecificDevice() {
        let videoDeviceId = this._mediaDevice.getCurrentDeviceId('videoinput');
        //document.getElementById('log_test').innerHTML += 'disableDefaultUserOfSpecificDevice>videoDeviceId:' + videoDeviceId + '<br>';
        
        if (!videoDeviceId) {
            await this._mediaDevice.update('video', this._devices['videoinput'][0].deviceId)
        }

        let audioDeviceId = this._mediaDevice.getCurrentDeviceId('audioinput');
        if (!audioDeviceId) {
            await this._mediaDevice.update('audio', this._devices['audioinput'][0].deviceId)
        }
    }

    checkMandatoryDevices(kind) {
        let mandatoryMissing = [];
        //if(kind == 'video')
        //    document.getElementById('log_test').innerHTML += JSON.stringify(this._devices) + ' > finded<br>';
        for (var i in this._mandatoryDevices) {
            if (!this._mandatoryDevices[i][kind])
                continue;
            if (this._mandatoryDevices[i][kind] && this._mandatoryDevices[i]['screen'])
                continue;
            let finded = false;
            for (var j in this._devices[kind + 'input']) {                
                if (this._devices[kind + 'input'][j].label.startsWith(this._mandatoryDevices[i].label)) {
                    //document.getElementById('log_test').innerHTML += this._mandatoryDevices[i].label + ' > finded<br>';
                    finded = true;
                    this._devices[kind + 'input'][j].role = this._mandatoryDevices[i].role;
                    this._devices[kind + 'input'][j].slug = this._mandatoryDevices[i].slug;
                    this._devices[kind + 'input'][j].id = this._mandatoryDevices[i].id;
                    this._mandatoryDevicesFinded.push(this._devices[kind + 'input'][j]);
                    delete this._devices[kind + 'input'][j];
                }
                else if (this._devices[kind + 'input'][j].label.indexOf('Entrée ligne') !== -1) {
                    delete this._devices[kind + 'input'][j];
                }
            }
            this._devices[kind + 'input'] = this._devices[kind + 'input'].filter(el => { return el != null && el != '' });
            if (!finded)
                mandatoryMissing.push(this._mandatoryDevices[i])
        }
        return mandatoryMissing;
    }

    processDevices() {
        this._mandatoryDevices = this._sdk.settings().devices;
        this._audioMandatoryMissing = this.checkMandatoryDevices('audio', this._devices);
        this._videoMandatoryMissing = this.checkMandatoryDevices('video', this._devices);
        console.log('processDevices', this._audioMandatoryMissing, this._videoMandatoryMissing)
    }

    async getDevices() {
        if (!this._devicesLoaded)
            await this.loadDevices();
        return {
            devices: this._devices,
            audioMandatoryMissing: this._audioMandatoryMissing,
            videoMandatoryMissing: this._videoMandatoryMissing
        }
    }

    retrieveCurrentDeviceId() {
        let d = this._sdk.settings().devices;
        for (var i in d) {
            if (d[i].id == this._sdk.session().onetoone().current_device) {
                this._currentSpecificDevice = d[i];
            }
        }
    }

    getScreenDevices() {
        return this._screenDevices;
    }

    async loadConsumers() {
        if (this.loading) {
            if (this.haveToLoadNext == true)
                return;
            this.haveToLoadNext = true;
            while (this.loading)
                await window.sdk.sleep(500);
        }
        let timeout = setTimeout(() => {
            window.sdk.event().emit('modalOpen', {
                variant: 'alert',
                title: 'Problème',
                content: 'Nous rencontrons un problème, cliquez sur ok pour continuer, ou rafraichissez la page',
                onConfirm: async () => {
                    this.haveToLoadNext = false;
                    this.loading = false;
                    this.loadConsumers();
                    window.sdk.event().emit('modalClose');
                }
            });
        }, 6000);
        this.loading = true;
        let error = false;
        try {
            let consumers = await this._producers.getPeer().sig('/consumers');
            await this.createConsumers(consumers);
        }
        catch(err) {
            error = true;
        }
        if(error) {
            await window.sdk.sleep(3000);
            let consumers = await this._producers.getPeer().sig('/consumers');
            await this.createConsumers(consumers);
        }
        this.haveToLoadNext = false;
        this.loading = false;
        clearTimeout(timeout);
        //this._sdk.event().emit('producersList', consumers, this._fakeConsumers);
    }

    async createConsumer(data) {        
        let myPeerId = this._producers.getPeer().getId();

        if (myPeerId == data.peerId && data.mediaTag.startsWith('cam'))
            return false;


        if (this._consumersHistory[data.producerId]) {
            return this._consumersHistory[data.producerId];
        }

        //this._consumersHistory[data.producerId] = 1;

        let consumer;
        if (data.fake) {
            consumer = {
                id: data.producerId, producerId: data.producerId, paused: true, mediaTag: data.mediaTag, appData: {
                    session_role: data.session.name,
                    mediaTag: data.mediaTag,
                    peerId: data.peerId,
                    fake: true
                }
            };
        }
        else {
            console.log('createConsumer', data)
            consumer = await this._consumers.consume(data.peerId, data.mediaTag);
            
            if (consumer !== false) {
                if (data.paused)
                    consumer.pause();                
                if (data.mediaTag.endsWith('audio')) {
                    this._audioManager.createMeter('audioMeter' + consumer.id, consumer.track, (data) => {
                        this._sdk.event().emit('audioMeter' + consumer.id, data)
                    });
                }
            }
        }
        this._consumersHistory[data.producerId] = consumer;
        return consumer;
    }

    async createConsumers(list) {
        let consumersList = {};
        for (var i in list) {
            let c = await this.createConsumer(list[i]);
            if (c !== false)
                consumersList[list[i].producerId] = c;
        }
        console.log('createConsumers', consumersList)
        this._sdk.event().emit('consumersList', consumersList)
    }

    async stopConsumes(data) {
        let consumers = await this._consumers.stopByPeerId(data.peerId);
        for (var i in consumers) {
            let { id, mediaTag } = consumers[i];
            if (mediaTag.endsWith('audio'))
                this._audioManager.stopMeter('audioMeter' + id);
        }
        this._sdk.event().emit('removeTracks', consumers);

        let myPeerId = this._producers.getPeer().getId();
        if (myPeerId != data.peerId)
            this._sdk.event().emit('peerExited', data);
    }

    async stopConsume(data) {
        console.log('stop consume', this.oldPeerId, data.peerId, data.mediaTag);

        if (this.oldPeerId == data.peerId)
            return;

        let consumer = await this._consumers.stop(data.peerId, data.mediaTag);

        if (data.mediaTag.endsWith('audio'))
            this._audioManager.stopMeter('audioMeter' + consumer.id);

        this._sdk.event().emit('removeTrack', consumer);
    }

    async pauseConsumer(data) {
        let consumer = await this._consumers.pause(data.peerId, data.mediaTag);
        if (consumer)
            this._sdk.event().emit('pauseTrack', consumer);
    }

    async resumeConsumer(data) {
        let consumer = await this._consumers.resume(data.peerId, data.mediaTag);
        if (consumer)
            this._sdk.event().emit('resumeTrack', consumer);
    }

    async removeFakeConsumer(data) {
        this.loadConsumers();
    }

    async startSfuSession(doc2uState) {
        if (doc2uState) {
            this.doc2uState = true;
            let doc2u = window.sdk.settings().devices.find((item) => item.label === 'doc2u');
            if(doc2u){
                this.doc2u = doc2u;
                doc2u.kind = "window";
                doc2u.deviceId = doc2u.id;
                this._mandatoryDevicesFinded.push(doc2u);
            }
        }
        this.socket = await this._sdk.connectSocketIO();
        this.socket.on('sfu', async(data) => {
            switch (data.action) {
                case "producerStarted":
                    //this.createConsumer(data);
                    this.loadConsumers();
                    break;
                case "producerPaused":
                    this.pauseConsumer(data);
                    break;
                case "producerResumed":
                    this.resumeConsumer(data);
                    break;
                /*case "producers": 
                    this.createConsumers(data.producersList);
                    break;*/
                case "peerProducerClosed":
                    this.stopConsumes(data);
                    this.loadConsumers();
                    break;
                case "producerClosed":
                    this.stopConsume(data);
                    this.loadConsumers();
                    break;
                case "needDevices":
                    if (this._sdk.session().isPatient()) {
                        setTimeout(() => {
                            this.sendDevices();
                        }, 1000) //timeout to prevent loop call                        
                    }
                    break;
                case "availableDevices":
                    if (this._sdk.session().isMedecin()) {
                        this.manageAvailableRemoteDevices(data.devices);
                    }
                    break;
                case "startSpecificDevice":
                    if (this._sdk.session().isPatient()){
                        if (data.device.role == 'Doc2u')
                            this._sdk.event().emit('specificCurrentDeviceUpdate', data.device.id);
                        else
                            this.startSpecificDevice(data.device);
                    }
                    break;
                case "stopSpecificDevice":
                    if (this._sdk.session().isPatient())
                        this.stopSpecificDevice(data.deviceId);
                    break;
                case "screenshareInvitation":
                    if (this._sdk.session().isPatient()) {
                        if (!this.screenShareWorkflowStarted)
                            this._sdk.event().emit('inviteToScreenshare', data.device);
                        else
                            this._producers.getPeer().sig('/screenshare-workflow-started');
                    }
                    break;
                case "screenshareInvitationRefuse":
                    if (this._sdk.session().isMedecin()) {
                        this._sdk.event().emit('screenshareInvitationRefuse', data.device);
                    }
                    break;
                case 'screenshare-workflow-started':
                    if (this._sdk.session().isMedecin()) {
                        this._sdk.event().emit('screenshare-workflow-started');
                    }
                    break;
                case "specificCurrentDeviceUpdate":
                    if (this._sdk.session().isMedecin()) {
                        this._sdk.event().emit('specificCurrentDeviceUpdate', data.deviceId);
                    }
                    break;
                case "snapshotRequest":
                    if (this._sdk.session().isPatient()) {
                        this._sdk.event().emit('snapshotRequest', data.snapshotType);
                    }
                    break;
                case "recordStarted":
                    this._sdk.event().emit('recordStarted', data.deviceId);
                    break;
                case "recordStopped":
                    this._sdk.event().emit('recordStopped');
                    break;
                case "recordPending":
                    this._sdk.event().emit('recordPending');
                    break;
                case "recordStartedFromServer":
                    this._sdk.event().emit('recordStartedFromServer');
                    break;
                case "recordStoppedFromServer":
                    this._sdk.event().emit('modalOpen', {
                        variant: 'alert',
                        title: 'Attention',
                        content: 'L\'enregistrement a été stoppé par le serveur car il dépasse la limite de temps autorisée.',
                        onConfirm: () => { 
                          this._sdk.event().emit('modalClose')
                        }
                      });
                      break;
                case "volume":
                    window.sdk.session().session.onetoone.volume_cam = data.volumeCam;
                    window.sdk.session().session.onetoone.volume_specific = data.volumeSpecific;
                    this._sdk.event().emit('volumeUpdated', data);
                    break;
                case "startRemoteRecord":
                    if (this._sdk.session().isPatient())
                        this.startRecord(data.mediaTags, data.deviceId);
                    break;
                case "stopScreenShare":
                    if (this._sdk.session().isPatient()) {
                        this._sdk.event().emit('screenShareStopped', window.sdk.videoconf().getCurrentSpecificDevice());
                        this.stopScreenShare();
                    }
                    break;
                case "newTransport":
                    window.sdk.videoconf().loadConsumers();
                    break;
            }
        });

        this._consumers = new Consumers();
        await this._consumers.init();
        this._consumers.setPreferredLayers(this._mediaDevice.getVideoResolution('recv'));

        this._producers = new Producers();
        await this._producers.init();
        this._producers.setActiveEncodings(this._mediaDevice.getVideoResolution('send'));

        await this.loadConsumers()

        let stream = this._mediaDevice.getStream();
        const tracks = stream.getTracks();
        for (let i in tracks) {
            let track = tracks[i];
            if (track.kind == 'video') {
                await this._producers.produceVideo(track);
            }
            if (track.kind == 'audio' && !this._micMute)
                await this._producers.produceAudio(track);
        }

        await this.sendDevices(doc2uState);

        if (this._sdk.session().isMedecin()) {
            let devices = await this._producers.getPeer().sig('/available-devices');
            this.manageAvailableRemoteDevices(devices);
        }

        this._isStarted = true;

        await this._producers.getPeer().sig('/sfu-connected');

        this.ping();

        this.pingInterval = setInterval(() => {
            this.ping();
        }, 30000);

        this.retrieveCurrentDeviceId();
    }

    async restartConsumers() {
        /*this._consumers.closeAll()
        await window.sdk.sleep(1000);
        this._consumers = new Consumers();
        await this._consumers.init();
        this._consumers.setPreferredLayers(this._mediaDevice.getVideoResolution('recv'));
        await this.loadConsumers()*/
        let consumers = this._consumers.getAll();
        for(var i in consumers) {
            await this.stopConsumes({peerId: i});
        }
        await this._consumers.removePeer();
        
        this._consumersHistory = {};
        this._sdk.event().emit('clearHistory');
        this._sdk.event().emit('consumersList', {})
        await window.sdk.sleep(100);
        this._consumers = new Consumers();
        await this._consumers.init();
        this._consumers.setPreferredLayers(this._mediaDevice.getVideoResolution('recv'));
        await this.loadConsumers()
    }

    async restartProducers() {
        this.oldPeerId = this._producers.getPeer().getId();
        try {
            await this._producers.removePeer();
        }
        catch(err) {

        }
        await window.sdk.sleep(500);
        this._producers = new Producers();
        await this._producers.init();
        this._producers.setActiveEncodings(this._mediaDevice.getVideoResolution('send'));   

        let stream = this._mediaDevice.getStream();
        const tracks = stream.getTracks();
        for (let i in tracks) {
            let track = tracks[i];
            if (track.kind == 'video') {
                await this._producers.produceVideo(track);
            }
            if (track.kind == 'audio' && !this._micMute)
                await this._producers.produceAudio(track);
        }
    }

    async sendDevices(doc2uState) {
        if (this._sdk.session().isPatient()) {
            if (!this._producers)
                return;
            await this._producers.getPeer().sig('/devices', {
                devices: {
                    mandatoryDevicesFinded: this._mandatoryDevicesFinded,
                    audioMandatoryMissing: this._audioMandatoryMissing,
                    videoMandatoryMissing: this._videoMandatoryMissing
                }
            })
        }
    }

    manageAvailableRemoteDevices(devices) {
        if (JSON.stringify(devices) == '{}') {
            devices = {
                mandatoryDevicesFinded: [],
                audioMandatoryMissing: [],
                videoMandatoryMissing: []
            }
        }
        for (var i in devices.mandatoryDevicesFinded) {
            for (var j in this._sdk.settings().devices) {
                if (devices.mandatoryDevicesFinded[i].label.startsWith(this._sdk.settings().devices[j].label)) {
                    devices.mandatoryDevicesFinded[i].role = this._sdk.settings().devices[j].role;
                    devices.mandatoryDevicesFinded[i].slug = this._sdk.settings().devices[j].slug;
                    devices.mandatoryDevicesFinded[i].dbId = this._sdk.settings().devices[j].id;
                }
            }
        }
        this._availableRemoteDevices = devices.mandatoryDevicesFinded;
        this._sdk.event().emit('availableRemoteDevices', devices)
    }

    updateProducer(data) {
        const tracks = data.stream.getTracks();
        for (let i in tracks) {
            let track = tracks[i];
            if (track.kind == 'video')
                this._producers.replaceTrack(track, 'cam-video');
            if (track.kind == 'audio')
                this._producers.replaceTrack(track, 'cam-audio');
        }
    }

    async toggleWebcamHide() {
        
        this._webcamHide ?
            await this._mediaDevice.resumeTrack('video')
            :
            await this._mediaDevice.pauseTrack('video')
        if (this._isStarted) { // && !isIOS check if this method cause a bug on IOS
            this._webcamHide ?
                await this._producers.resume('cam-video')
                :
                await this._producers.pause('cam-video')
        }
        this._webcamHide = !this._webcamHide
        this._sdk.event().emit('toggleWebcam', this._webcamHide)
    }

    isWebcamHide() {
        return this._webcamHide;
    }

    toggleMicMute() {
        this._micMute ?
            this._mediaDevice.resumeTrack('audio')
            :
            this._mediaDevice.pauseTrack('audio')
        if (this._isStarted) {
            this._micMute ?
                this._producers.resume('cam-audio')
                :
                this._producers.pause('cam-audio')
        }
        this._micMute = !this._micMute
        this._sdk.event().emit('toggleMic', this._micMute)
    }

    isMicMute() {
        return this._micMute;
    }

    isStarted() {
        return this._isStarted;
    }

    async requestStopScreenShare() {
        await this._producers.getPeer().sig('/request-stop-screenshare')
    }

    stopScreenShare() {
        this._mediaDevice.removeScreenShareStream();
        this._producers.close('screen-video');
        try {
            this._producers.close('screen-audio');
        }
        catch (err) {

        }
        this._producers.updateBitrate('cam-video', 2);
    }

    async startScreenShare(audio = false, appData = {}) {
        this.screenShareWorkflowStarted = true;

        let stream = await this._mediaDevice.getScreenShareStream({
            audio,
            onStop: () => {
                this.stopScreenShare();
                this._sdk.event().emit('screenShareStopped', appData);
            }
        });

        if (!stream) {
            this.screenShareWorkflowStarted = false;
            this._sdk.event().emit('startScreenshareFailed');
            return;
        }
        this._producers.updateBitrate('cam-video', 0.5);
        const tracks = stream.getTracks();
        for (let i in tracks) {
            let track = tracks[i];
            if (track.kind == 'video')
                await this._producers.produceVideo(track, 'screen-video', appData);
            if (track.kind == 'audio')
                await this._producers.produceAudio(track, 'screen-audio', appData);
        }

        this.screenShareWorkflowStarted = false;

        return true;
    }

    // async startDoc2u(token) {
    //     this.screenShareWorkflowStarted = true;

    //     let stream = await this._mediaDevice.getScreenShareStream({
    //         audio,
    //         onStop: () => {
    //             this.stopScreenShare();
    //             this._sdk.event().emit('screenShareStopped', appData);
    //         }
    //     });

    //     if (!stream) {
    //         this.screenShareWorkflowStarted = false;
    //         this._sdk.event().emit('startScreenshareFailed');
    //         return;
    //     }
    //     this._producers.updateBitrate('cam-video', 0.5);
    //     const tracks = stream.getTracks();
    //     for (let i in tracks) {
    //         let track = tracks[i];
    //         if (track.kind == 'video')
    //             await this._producers.produceVideo(track, 'screen-video', appData);
    //         if (track.kind == 'audio')
    //             await this._producers.produceAudio(track, 'screen-audio', appData);
    //     }

    //     this.screenShareWorkflowStarted = false;

    //     return true;
    // }

    async getSpecificDevices() {
        if (this._sdk.session().isPatient())
            return this._mandatoryDevicesFinded;

        if (this._sdk.session().isMedecin())
            return this._availableRemoteDevices;
    }

    async startSpecificDevice(device) {     
        console.log('startSpecificDevice', device)   
        if (this._sdk.session().isPatient()) {                                        
            if(this.specificDeviceIsStarting) {                
                return;
            }

            if(isIOS && this._sdk.session().isPatient()) {
				if(!this.isWebcamHide()) {
					this.needToReenableWebcam = true;
					this.disableWebcam = true;
					await this.toggleWebcamHide();
				}
			}	

            this.specificDeviceIsStarting = true;
            await this.startProduceSpecificDevice(device.deviceId, device.kind, device);
            this.setCurrentSpecificDevice(device);            
            this.specificDeviceIsStarting = false;            
        }

        if (this._sdk.session().isMedecin()) {
            this._sdk.event().emit('startProduceSpecificDevice', 'starting', device.deviceId);
            await this._producers.getPeer().sig('/start-device', {
                device
            })
            this._sdk.event().emit('specificDevice', 'started', device.deviceId, device.label);
        }

        return true;

    }

    async stopSpecificDevice(deviceId) {
        if (this._sdk.session().isPatient()) {
            if(!deviceId || JSON.stringify(deviceId) == '{}') {
                deviceId = this.getCurrentSpecificDevice().deviceId;
            }
            try {
                if (window.sdk.settings().devices.find((item) => item.role === 'Doc2u').id === deviceId){
                    this._sdk.event().emit('specificDevice', 'stopped', deviceId);
                }
            }
            catch(err) {
                
            }
            await this.stopProduceSpecificDevice(deviceId);

            if(this.needToReenableWebcam) {
                this.disableWebcam = false;
                this.needToReenableWebcam = false;
                this.toggleWebcamHide();                
            }            

            
        } else if (this._sdk.session().isMedecin()) {
            await this._producers.getPeer().sig('/stop-device', {
                deviceId
            })
            this._sdk.event().emit('specificDevice', 'stopped', deviceId);
        }
    }

    async startProduceSpecificDevice(deviceId, media, device) {

        console.log('startProduceSpecificDevice 2', deviceId, media, device)   

        this._sdk.event().emit('loadingStart');

        this._producers.updateBitrate('cam-video', 0.5);

        if (media && media.endsWith('input'))
            media = media.split('input').shift();

        this._sdk.event().emit('specificDevice', 'starting', deviceId);

        let stream = null;
        if (device.role !== 'Doc2u')
            stream = await this._mediaDevice.getSpecificDeviceStream({
                deviceId, media
            });

        this._specificDevices[deviceId] = {
            media, stream
        }

        let deviceInfo = {};
        for (var i in this._mandatoryDevicesFinded) {
            if (this._mandatoryDevicesFinded[i].deviceId == deviceId)
                deviceInfo = this._mandatoryDevicesFinded[i];
        }

        if(!device.id)
            device.id = deviceInfo.id;
        let tracks;
        if (stream){
            tracks = stream.getTracks();

       for (let i in tracks) {
            let track = tracks[i];
            if (media == 'video')
                await this._producers.produceVideo(track, deviceId + '-video', deviceInfo);
            if (media == 'audio')
                await this._producers.produceAudio(track, deviceId + '-audio', deviceInfo);
        }}
        //TODO handle error
        this._sdk.event().emit('specificDevice', 'started', deviceId, deviceInfo, device.label);

        this._sdk.event().emit('loadingStop');
    }

    async stopProduceSpecificDevice(deviceId) {
        let device = this._specificDevices[deviceId];
        if (device) {

            let deviceInfo = {};
            for (var i in this._mandatoryDevicesFinded) {
                if (this._mandatoryDevicesFinded[i].deviceId == deviceId)
                    deviceInfo = this._mandatoryDevicesFinded[i];
            }

            this._mediaDevice.removeSpecificDeviceStream(device.stream);
            this._producers.close(deviceId + '-' + device.media);
            this._sdk.event().emit('specificDevice', 'stopped', deviceId, deviceInfo);

            this._producers.getPeer().sig('/current-specific-device/close', {
                deviceId: null
            })
        }
        this._producers.updateBitrate('cam-video', 2);
    }

    async restartProducer() {
        this.oldPeerId = this._producers.getPeer().getId();
        try {
            await this._producers.removePeer();
        }
        catch(err) {

        }
        await window.sdk.sleep(500);
        this._producers = new Producers();
        await this._producers.init();
        this._producers.setActiveEncodings(this._mediaDevice.getVideoResolution('send'));   

        let stream = this._mediaDevice.getStream();
        const tracks = stream.getTracks();
        for (let i in tracks) {
            let track = tracks[i];
            if (track.kind == 'video') {
                await this._producers.produceVideo(track);
            }
            if (track.kind == 'audio' && !this._micMute)
                await this._producers.produceAudio(track);
        }
    }

    async closeProducer(mediaTag) {
        await this._producers.close(mediaTag);
    }

    async sendScreenShareInvitation(device) {
        this._producers.getPeer().sig('/screenshare-invitation', {
            device
        })
    }
    async sendScreenshareInvitationRefuse(device) {
        this._producers.getPeer().sig('/screenshare-refuse', {
            device
        })
    }
    async setVolume(values) {
        this._producers.getPeer().sig('/volume', values)
    }

    async executeSnapshot(isRemote) {
        if(this._sdk.session().isMedecin()) {
			this.sendSnapshotRequest();
			return;
		}
        
        let video = document.getElementById('webcam-preview');

        if(!video) {
            this._sdk.event().emit('modalOpen', {
                 variant: 'alert',
                 title: 'Attention',
                 content: 'Pas de vidéo disponible',
                 onConfirm: () => { 
                   this._sdk.event().emit('modalClose')
                 }
               });         
        }
        else {
            let device = this.getCurrentSpecificDevice();
            if(device && device.role !== "Doc2u") {
                if(device.id)
		            video = document.querySelector('.deviceId-' + device.id); //for screen share
                else
                    video = document.querySelector('.specific-' + device.deviceId + '-video'); //for video specific evice
            }
            else if(document.querySelector('[data-sessionrole="extern"]')) //for extern camera, priority is given to specfic device, if you want to prioritiez extern cam, juste replace else if by if
                video = document.querySelector('[data-sessionrole="extern"]');	

            try {
                if(video.parentNode.classList.contains('video-block--paused'))
                    video = document.getElementById('webcam-preview');
            }
            catch(err) {

            }
            this.snapshot(video, isRemote);
        }
    }

    async snapshot(video, isRemote) {

        if (!isRemote)
            this._sdk.event().emit('loadingStart');

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var w, h, ratio;

        ratio = video.videoWidth / video.videoHeight;
        w = video.videoWidth;
        h = video.videoHeight;
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(video, 0, 0, w, h);
        var img = canvas.toDataURL('image/jpg');

        let role = video.getAttribute('data-role') || 'webcam';
        //document.body.innerHTML += '<img src="' + img + '" />';
        let res = await this._sdk.fetch().post('/snapshot', {
            body: {
                img, role
            }
        });

        if(res.msg == 'max_screenshots_reached') {
            this._sdk.event().emit('modalOpen', {
                variant: 'alert',
                title: 'Attention',
                content: 'Vous avez atteint le nombre maximum de captures d\'écran',
                onConfirm: () => { 
                  this._sdk.event().emit('modalClose')
                }
              });
        }

        if (!isRemote) {
            await window.sdk.sleep(500);
            this._sdk.event().emit('loadingStop');
        }
    }

    async sendSnapshotRequest(type = false) {
        this._sdk.event().emit('loadingStart');

        if (type == false) {
            type = this.getCurrentSpecificDevice() ? 'specificDevice' : 'webcam'
        }

        let res = await this._producers.getPeer().sig('/snapshot-request', {
            snapshotType: type
        })

        await window.sdk.sleep(500);

        this._sdk.event().emit('loadingStop');

        return res;
    }

    async setCurrentSpecificDevice(device) {
        this._currentSpecificDevice = device;
        if (this._sdk.session().isPatient()) {
            let action = 'start';
            if (!device)
                action = 'close';
            let deviceId = device.id;
            /*if(!deviceId) {
                deviceId = document.querySelector('.specific-' + device.deviceId + '-video').getAttribute('data-dbdeviceid').split('-').pop()
            }*/
            return await this._producers.getPeer().sig('/current-specific-device/' + action, {
                deviceId: deviceId
            })
        }
    }

    getCurrentSpecificDevice() {
        return this._currentSpecificDevice;
    }

    async startRecord(mediaTags, deviceId = null) {
        let res = await this._producers.getPeer().sig('/start-record', {
            mediaTags, deviceId
        })
        if(res.msg == 'max_record_reached') {
            this._sdk.event().emit('modalOpen', {
                variant: 'alert',
                title: 'Attention',
                content: 'Vous avez atteint le nombre maximum d\'enregistrements',
                onConfirm: () => { 
                  this._sdk.event().emit('modalClose')
                }
              });
        }
    }

    async stopRecord() {
        return await this._producers.getPeer().sig('/stop-record')
    }

    consumers() {
        return this._consumers;
    }

    async exit() {        
        this._sdk.fetch().sendBeacon('/signaling/exit', {
            peerTokens: [this._producers.getPeer().getToken(), this._consumers.getPeer().getToken()]
        });
        this._mediaDevice.stop();
    }

    ping() {
        this._sdk.fetch().sendBeacon('/signaling/ping', {
            peerTokens: [this._producers.getPeer().getToken(), this._consumers.getPeer().getToken()]
        });
    }
}